// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import tripTravellerEntity from './entities/trip-traveller.json';
import tripTravellerMenu from '../pages/trip-traveller/menu.json';
import tripTravellerFullForm from '../pages/trip-traveller/forms/full.json';
import tripTravellerContextForm from '../pages/trip-traveller/forms/context.json';
import tripTravellerMiniForm from '../pages/trip-traveller/forms/mini.json';
import tripTravellerLookupForm from '../pages/trip-traveller/forms/lookup.json';
import tripTravellerTableView from '../pages/trip-traveller/views/table.json';
import tripTravellerCardsView from '../pages/trip-traveller/views/cards.json';
import tripTravellerCalendarView from '../pages/trip-traveller/views/calendar.json';
import tripTravellerDashboardView from '../pages/trip-traveller/views/dashboard.json';

/** Тип запису «Відряджений» зі сторінками пакета: меню, форми та подання з pages/trip-traveller/. */
export const tripTravellerDefinition: IRecordTypeDefinition = {
  ...tripTravellerEntity,
  views: assembleViewSet({
      table: tripTravellerTableView,
      cards: tripTravellerCardsView,
      calendar: tripTravellerCalendarView,
      dashboard: tripTravellerDashboardView,
  }),
  form: tripTravellerFullForm,
  forms: { full: tripTravellerFullForm, context: tripTravellerContextForm, mini: tripTravellerMiniForm, lookup: tripTravellerLookupForm },
  menu: tripTravellerMenu,
} as IRecordTypeDefinition;
